import script from "./OpeningSequence.vue?vue&type=script&setup=true&lang=js"
export * from "./OpeningSequence.vue?vue&type=script&setup=true&lang=js"

import "./OpeningSequence.vue?vue&type=style&index=0&id=418980de&scoped=true&lang=css"

import exportComponent from "../../../../../20260930-ui-unification/project/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-418980de"]])

export default __exports__